var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ChangeDetectionStrategy, Component, HostListener, ViewChild } from '@angular/core';
import { ColumnBaseComponent } from '../base/columnbase.component';
import { ColumnService } from '../column/column.service';
import { ColumnBaseService } from '../base/columnbase.service';
import { CLEditorService } from './cleditor.service';
var CLEditorComponent = /** @class */ (function (_super) {
    __extends(CLEditorComponent, _super);
    function CLEditorComponent(service, baseService, cleditorService) {
        var _this = _super.call(this, service, baseService) || this;
        _this.service = service;
        _this.baseService = baseService;
        _this.cleditorService = cleditorService;
        _this.controls = [
            ['bold', 'italic', 'underline', 'strikethrough', 'subscript', 'superscript'],
            ['font', 'size', 'style'],
            ['color', 'highlight', 'removeformat'],
            ['bullets', 'numbering'],
            ['outdent', 'indent'],
            ['alignleft', 'center', 'alignright', 'justify'],
            ['undo', 'redo'],
            ['rule', 'image', 'link', 'unlink'],
            ['cut', 'copy', 'paste', 'pastetext'],
            ['print', 'source']
        ];
        _this.updateFrameFlg = false;
        _this.defaultOptions = {
            width: 'auto',
            height: 250,
            controls: 'bold italic underline strikethrough subscript superscript | font size ' +
                'style | color highlight removeformat | bullets numbering | outdent ' +
                'indent | alignleft center alignright justify | undo redo | ' +
                'rule image link unlink | cut copy paste pastetext | print source',
            colors: 'FFF FCC FC9 FF9 FFC 9F9 9FF CFF CCF FCF ' +
                'CCC F66 F96 FF6 FF3 6F9 3FF 6FF 99F F9F ' +
                'BBB F00 F90 FC6 FF0 3F3 6CC 3CF 66C C6C ' +
                '999 C00 F60 FC3 FC0 3C0 0CC 36F 63F C3C ' +
                '666 900 C60 C93 990 090 399 33F 60C 939 ' +
                '333 600 930 963 660 060 366 009 339 636 ' +
                '000 300 630 633 330 030 033 006 309 303',
            fonts: 'Arial,Arial Black,Comic Sans MS,Courier New,Narrow,Garamond,' +
                'Georgia,Impact,Sans Serif,Serif,Tahoma,Trebuchet MS,Verdana',
            sizes: '1,2,3,4,5,6,7',
            styles: [
                ['Paragraph', '<p>'], ['Header 1', '<h1>'], ['Header 2', '<h2>'],
                ['Header 3', '<h3>'], ['Header 4', '<h4>'], ['Header 5', '<h5>'],
                ['Header 6', '<h6>']
            ],
            useCSS: true,
            docType: '<!DOCTYPE HTML PUBLIC "-//W3C//DTD HTML 4.01 Transitional//EN" "http://www.w3.org/TR/html4/loose.dtd">',
            docCSSFile: '',
            bodyStyle: 'margin:4px; font:10pt Arial,Verdana; cursor:text'
        };
        return _this;
    }
    CLEditorComponent.prototype.ngOnChanges = function (changes) {
        var changeValFlg = this.changeValFlg;
        _super.prototype.ngOnChanges.call(this, changes);
        if (changes.col && !changes.col.firstChange) {
            this.setDisable();
        }
        if (changes.val && !changes.val.firstChange && !changeValFlg) {
            this.setVal();
        }
    };
    CLEditorComponent.prototype.ngOnInit = function () {
        var _this = this;
        _super.prototype.ngOnInit.call(this);
        this.refreshSubscription = this.cleditorService.observable.subscribe(function (timeout) {
            _this.onResize(timeout);
        });
    };
    CLEditorComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.element = this.editorElement.nativeElement;
        this.editor = $(this.element).cleditor(this.setOptions())[0];
        this.onResize(0);
        $(this.editor).on('change', function () {
            if (_this.updateFrameFlg) {
                _super.prototype.onChange.call(_this, $(_this.element).val(), false);
                _this.updateFrameFlg = false;
            }
            else {
                _super.prototype.onChange.call(_this, $(_this.element).val());
            }
        });
        this.setDisable();
        this.setVal();
    };
    CLEditorComponent.prototype.setOptions = function () {
        var options = JSOG.parse(JSON.stringify(this.defaultOptions));
        var params = this.col.params || {};
        var toolbar = params.toolbar || {};
        var tools = [];
        for (var _i = 0, _a = this.controls; _i < _a.length; _i++) {
            var controls = _a[_i];
            var data = [];
            for (var _b = 0, controls_1 = controls; _b < controls_1.length; _b++) {
                var control = controls_1[_b];
                if (toolbar[control] !== false) {
                    data.push(control);
                }
            }
            if (data.length > 0) {
                data.push('|');
            }
            tools = tools.concat(data);
        }
        tools.pop();
        options['controls'] = tools.join(' ');
        options['width'] = '100%';
        var form = params.formClass || {};
        if (form.height && typeof form.height === 'string') {
            options['height'] = '100%';
        }
        var opt = params.options || {};
        var optKeys = ['colors', 'fonts', 'sizes', 'styles', 'useCSS', 'docType', 'docCSSFile', 'bodyStyle'];
        for (var _c = 0, optKeys_1 = optKeys; _c < optKeys_1.length; _c++) {
            var key = optKeys_1[_c];
            if (opt[key]) {
                options[key] = opt[key];
            }
        }
        return options;
    };
    CLEditorComponent.prototype.setDisable = function () {
        if (this.editor) {
            this.editor.disable(this.col.readonly);
        }
    };
    CLEditorComponent.prototype.setVal = function () {
        if (this.editor && ($(this.element).val() || this.val)) {
            $(this.element).val(this.val);
            this.updateFrameFlg = true;
            this.editor.updateFrame();
        }
    };
    CLEditorComponent.prototype.onResize = function (timeout) {
        var _this = this;
        if (timeout === void 0) { timeout = 300; }
        window.clearTimeout(this.timeoutID);
        this.timeoutID = window.setTimeout(function () {
            if (_this.editor) {
                _this.editor.refresh();
            }
        }, timeout);
    };
    CLEditorComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        this.refreshSubscription.unsubscribe();
        this.editor.clearPopups();
        $(window).unbind('.cleditor');
    };
    CLEditorComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'column-cleditor',
                    template: '<div [key]="key" [col]="col" columnDir></div><textarea name="{{ colKey }}" attr.name="{{ colKey }}" #editor></textarea>',
                    changeDetection: ChangeDetectionStrategy.OnPush
                }] }
    ];
    /** @nocollapse */
    CLEditorComponent.ctorParameters = function () { return [
        { type: ColumnService },
        { type: ColumnBaseService },
        { type: CLEditorService }
    ]; };
    CLEditorComponent.propDecorators = {
        editorElement: [{ type: ViewChild, args: ['editor',] }],
        onResize: [{ type: HostListener, args: ['window:resize',] }]
    };
    return CLEditorComponent;
}(ColumnBaseComponent));
export { CLEditorComponent };
//# sourceMappingURL=cleditor.component.js.map